import Vue from 'vue'
import axios from 'axios'
import SocialSharing from 'vue-social-sharing'
import cloneDeep from 'lodash.clonedeep'
import Waitlist from './Components/waitlist.vue'
import RegistrationForm from './Components/registration-form.vue'
import Throttle from './Components/throttle.vue'
import AccessCode from './Components/access-code.vue'
import ModalRemindMe from './Components/modal-remind-me.vue'

import {AxiosRedirectIntercepted} from '../Shared/errors'
import {
    trackAddToCart,
    trackBeginCheckout,
    trackIdle,
    trackShare,
    trackViewProduct
} from '../Shared/analytics'
import { injectHideyShowyHack } from "./hideyShowyHack";

const RESERVATION_FAILED_STATUS = 1

const hasCartExpired = () => {
    var field = 'expired'
    var url = window.location.href
    if (url.indexOf('?' + field + '=') != -1) return true
    else if (url.indexOf('&' + field + '=') != -1) return true
    return false
}

const preLoadeddata = cloneDeep(window.preLoadeddata);

const vm = new Vue({
    el: '#events-page',
    data: Object.assign(preLoadeddata, {
        pageIndex: 1,
        showModal: false,
        modalTitle: '',
        modalType: 'info',
        modalMessage: '',
        busy: false,
        showNoTicketsSelectedAlert: false,
        showMustPurchaseAdditionalTicketsAlert: false,
        showMustPurchaseAdditionalTicketsAlertMessage: '',
        showExpiredAlert: hasCartExpired(),
        showAddToCalendar: false,
        showRemindMeModal: false,
        autoScanEnabled: preLoadeddata.autoScanPreference,
    }),
    components: {
        SocialSharing,
        Waitlist,
        Throttle,
        AccessCode,
        RegistrationForm,
        ModalRemindMe
    },
    mounted() {
        //Simulating an equivalent of document.ready (to be used in bootstrapping google tag manager to subscribe to events etc)
        this.$nextTick(function () {
            const applicationReadyEvent = new CustomEvent("application-ready", {
                detail: { when: Date() }
            })

            if (this.hideyShowyHackEnabled === true) {
                injectHideyShowyHack(this);
            }
          
            document.body.dispatchEvent(applicationReadyEvent);
            trackViewProduct({ id: this.eventId, name: this.eventName});            
        });
        setInterval(trackIdle, 60 * 1000);
    },
    watch: {
        // clear an alerts whenever there are changes
        // to requested inventory
        requestedInventory: {
            handler() {
                this.showNoTicketsSelectedAlert = false
                this.showMustPurchaseAdditionalTicketsAlert = false
                ;(this.showMustPurchaseAdditionalTicketsAlertMessage = ''),
                    (this.showExpiredAlert = false)
                this.accessCode.showWarning = false

                const requestedInventoryChangedEvent = new CustomEvent(
                    "requested-inventory-changed",
                    { detail: { when: Date(), vm: this } }
                )
                document.body.dispatchEvent(requestedInventoryChangedEvent);
            },
            deep: true,
            //immediate: true,
        },
        autoScanPreference: {
            handler() {
            },
            deep: true,
        }
    },
    computed: {
        showTotal() {
            return this.anyTicketsSelected
        },

        selectedTickets() {
            return Object.keys(this.requestedInventory)
                .filter(inventoryId => this.requestedInventory[inventoryId] > 0)
                .map(inventoryId => {
                    const quantity = this.requestedInventory[inventoryId]
                    const inventoryItem = this.inventory[inventoryId]
                    
                    return {
                        inventoryId,
                        quantity,
                        name: inventoryItem.name,
                        price: inventoryItem.price,
                        total: inventoryItem.price * quantity,
                        bookingFee: inventoryItem.bookingFee,
                        totalBookingFee: inventoryItem.bookingFee * quantity,
                        requiresAnyOfTheseInventoriesToBeSelected:
                            inventoryItem.requiresAnyOfTheseInventoriesToBeSelected,
                        priceBase: inventoryItem.price - inventoryItem.bookingFee
                    }
                })
        },

        requestedInventoryToPost() {
            return this.selectedTickets.reduce((obj, ticket) => {
                obj[ticket.inventoryId] = ticket.quantity
                return obj
            }, {})
        },

        anyTicketsSelected() {
            return this.selectedTickets.length
        },

        total() {
            return this.selectedTickets
                .map(ticket => ticket.total)
                .reduce((total, current) => total + current, 0)
        },

        totalBookingFees() {
            return this.selectedTickets
                .map(ticket => ticket.totalBookingFee)
                .reduce((totalBookingFee, current) => totalBookingFee + current, 0)
        },

        showNextButton() {
            return this.pageIndex < this.totalNumberOfPages
        },

        showPreviousButton() {
            return this.totalNumberOfPages > 1 && this.showGetTicketsButton
        },

        showGetTicketsButton() {
            return !this.showNextButton
        },

        showTransactionFeeMessage() {
            return this.transactionFeesTotalDollarValue > 0 || this.transactionFeesTotalPercentValue > 0;
        },

        totalTransactionFeeAmount() {
            if (this.total < this.transactionFeesMinimumAmount) return 0;
            
            return (this.transactionFeesTotalDollarValue != null ? this.transactionFeesTotalDollarValue : 0)
                + (this.total * (this.transactionFeesTotalPercentValue != null ? (this.transactionFeesTotalPercentValue / 100) : 0));
        },

        totalTransactionFeeMessage() {
            if (this.showTransactionFeeMessage) {
                if (this.anyTicketsSelected) {
                    return `additional Transaction Fee of $${this.totalTransactionFeeAmount.toFixed(2)} applies`;
                } else {
                    let transactionFeeAmountString = '';
                    if (this.transactionFeesTotalDollarValue > 0) {
                        transactionFeeAmountString += `$${this.transactionFeesTotalDollarValue.toFixed(2)}`;
                    }
                    if (this.transactionFeesTotalPercentValue > 0) {
                        if (transactionFeeAmountString.length > 0) {
                            transactionFeeAmountString += ' + ';
                        }
                        transactionFeeAmountString += `${this.transactionFeesTotalPercentValue.toFixed(2)}%`;
                    }
                    return `additional Transaction Fee of ${transactionFeeAmountString} applies`;
                }
            }
            return '';
        },
    },
    methods: {

        quantities(ticketId) {
            const size =
                this.inventory[ticketId].maximumQuantity <
                this.inventory[ticketId].minimumQuantity
                    ? this.inventory[ticketId].maximumQuantity
                    : this.inventory[ticketId].maximumQuantity -
                    this.inventory[ticketId].minimumQuantity +
                    1;

            return [...Array(size)].map((_, i) => ({
                key: `${ticketId}-${i}`,
                value: i + this.inventory[ticketId].minimumQuantity,
            }));
        },

        moveToNextPage() {
            this.pageIndex = this.pageIndex + 1
            const transitionInMs = 500
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, transitionInMs)
        },

        moveToPreviousPage() {
            this.pageIndex = this.pageIndex - 1
            this.showNoTicketsSelectedAlert = false
            this.showMustPurchaseAdditionalTicketsAlert = false
        },

        onSocialShareOpen(network, url) {
            trackShare(network, url)
        },

        showNoTicketsSelectedAlertAndSetFocus() {
            this.showNoTicketsSelectedAlert = true
            this.showExpiredAlert = false
            this.$nextTick(() => this.$refs.noTicketsSelectedAlert.focus())
        },

        showMustPurchaseAdditionalTicketsAlertAndFocus(message) {
            this.showMustPurchaseAdditionalTicketsAlert = true
            this.showMustPurchaseAdditionalTicketsAlertMessage = message
            this.showExpiredAlert = false
            this.$nextTick(() =>
                this.$refs.mustPurchaseAdditionalTicketsAlert.focus(),
            )
        },

        addTicket(inventoryId) {
            const { minimumQuantity, maximumQuantity } = this.inventory[
                inventoryId
            ]
            const currentNumberOfTickets = this.requestedInventory[inventoryId]
            if (this.requestedInventory[inventoryId] < maximumQuantity) {
                const numberOfTicketsToAdd =
                    currentNumberOfTickets == 0 ? minimumQuantity : 1
                this.requestedInventory[inventoryId] += numberOfTicketsToAdd
            }
        },

        removeTicket(inventoryId) {
            const { minimumQuantity, maximumQuantity } = this.inventory[
                inventoryId
            ]
            const currentNumberOfTickets = this.requestedInventory[inventoryId]
            if (this.requestedInventory[inventoryId] != 0) {
                const numberOfTicketsToRemove =
                    currentNumberOfTickets == minimumQuantity
                        ? minimumQuantity
                        : 1
                this.requestedInventory[inventoryId] -= numberOfTicketsToRemove
            }
        },

        isRemoveDisabled(inventoryId) {
            return this.requestedInventory[inventoryId] == 0
        },

        isAddDisabled(inventoryId) {
            return (
                this.requestedInventory[inventoryId] ==
                this.inventory[inventoryId].maximumQuantity
            )
        },

        activeClass(inventoryId) {
            return this.requestedInventory[inventoryId] > 0 ? 'active' : ''
        },

        showOnCurrentPage(inventoryId) {
            return this.inventory[inventoryId].pageToShowOn == this.pageIndex
        },

        redirectToPage(redirectTo) {
            window.location = redirectTo
        },

        handleReservationFailure() {
            this.showModalDialog(
                'Tickets are reserved',
                'The ticket(s) you requested are currently reserved by other customers. Try selecting a smaller number of tickets, a different ticket type or try again later.',
            )
        },

        handleError(error) {
            if (error instanceof AxiosRedirectIntercepted) return

            console.error('Something went wrong', error)

            this.showModalDialog(
                'Something went wrong',
                'Oops! Something went wrong. Wanna try again?',
            )
        },

        showModalDialog(title, message) {
            this.showModal = true
            this.modalTitle = title
            this.modalMessage = message
        },

        showAddToCalendarDialog() {
            this.showAddToCalendar = true
            document.body.className += ' ' + 'modal-open'
        },

        closeAddToCalendarDialog() {
            window.location.reload(true)
        },

        showBusy() {
            this.busy = true
            return Promise.resolve()
        },
        hideBusy() {
            this.busy = false
        },
        validate() {
            if (!this.anyTicketsSelected) {
                this.showNoTicketsSelectedAlertAndSetFocus()
                return false
            }

            var invalidTickets = this.ticketsRequiringOtherInventoriesToBeSelected()
            if (invalidTickets.length) {
                const message = `${invalidTickets.join(
                    ', ',
                )} can only be purchased with an additional ticket selection`
                this.showMustPurchaseAdditionalTicketsAlertAndFocus(message)
                return false
            }

            return true
        },

        ticketsRequiringOtherInventoriesToBeSelected() {
            var selectedInventoryIds = this.selectedTickets.map(
                ticket => ticket.inventoryId,
            )

            const ticketRequiresOtherInventoriesToBeSelected = ticket =>
                ticket.requiresAnyOfTheseInventoriesToBeSelected.length &&
                ticket.requiresAnyOfTheseInventoriesToBeSelected.every(
                    inventoryId =>
                        selectedInventoryIds.indexOf(inventoryId) == -1,
                )

            return this.selectedTickets
                .filter(ticketRequiresOtherInventoriesToBeSelected)
                .map(ticket => ticket.name)
        },

        trackCartActions(cartId) {
            var analyticsData = {
                eventId: this.eventId,
                eventName: this.eventName,
                inventory: this.selectedTickets.map(ticket => ({
                    id: ticket.inventoryId,
                    name: ticket.name,
                    quantity: ticket.quantity,
                    price: ticket.price,
                    priceBase: ticket.priceBase.toFixed(2)
                })),
                total: this.total,
                cartId: cartId,
                venueName: this.venueDescription
            }

            trackAddToCart(analyticsData);
            trackBeginCheckout(analyticsData);
        },
        
        submit(event) {
            if (!this.validate()) return
            
            this.showBusy()
                .then(this.postTickets(event.target.action))
                .then(response => {
                    const { status, redirectUrl, cartId } = response.data

                    if (status === RESERVATION_FAILED_STATUS) {
                        this.handleReservationFailure()
                        return
                    }

                    this.trackCartActions(cartId)
                    this.redirectToPage(redirectUrl)
                })
                .catch(this.handleError)
        },

        postTickets(url) {
            return () =>
                axios.post(url, {
                    accessCodeId: this.accessCode.accessCodeId,
                    accessCode: this.accessCode.accessCode,
                    autoScanForOrder: this.autoScanEnabled,
                    requestedInventory: this.requestedInventoryToPost,
                })
        },

        addCurrentQuerystringIfAnchorClicked(event) {
            const wasAnAnchorClick =
                event && event.target && event.target.tagName
                    ? event.target.tagName.toLowerCase() === 'a'
                    : false

            if (!wasAnAnchorClick) return false

            const originalHref = event.target.href

            // need to use .event.target.getAttribute('href') rather than event.target.href
            // as event.target.href will always return an absolute url
            var isHrefIsAFragment = (event.target.getAttribute('href') || '').indexOf('#') === 0
            if (isHrefIsAFragment) {
                window.location.href = originalHref
                return
            }

            const currentQuerystring = window.location.search.substring(1)

            if (currentQuerystring === '') {
                window.location.href = originalHref
            } else {
                const originalHrefHasQuerystring =
                    originalHref.indexOf('?') !== -1
                const separator = originalHrefHasQuerystring ? '&' : '?'

                window.location.href =
                    originalHref + separator + currentQuerystring
            }
        },
        handleRemindMeClick() {
            this.showRemindMeModal = true
        },
        closeRemindMeModal() {
            this.showRemindMeModal = false
        },
        getButtonPriceDescription(deliveryFeeMessage) {
            let bookingFeeText = '';
            
            if (this.anyTicketsSelected) {
                bookingFeeText = `Price includes Booking Fee of $${this.totalBookingFees.toFixed(2)}.`;
            } else {
                bookingFeeText = `Price includes Booking Fees.`;
            }
            
            let additionalFeeArray = [this.totalTransactionFeeMessage, deliveryFeeMessage].filter(Boolean);
            
            if (additionalFeeArray.length > 0) {
                bookingFeeText += ' An ' + additionalFeeArray.join(' and an ') + ' per order.';
            }
            
            return bookingFeeText;
        },
        updateAutoScanCallback(newValue) {
            this.autoScanPreference = newValue;
        }
    },
})



// WEBPACK FOOTER //
// ./Features/Event/index.js